module.exports = __webpack_public_path__ + "static/media/Nguyen_Phi_Le.99c697bb.svg";